<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['AIChat'],
      }"
      @click="configMainShow['AIChat'] = !configMainShow['AIChat']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>AI 互动</span>
        <span class="el-switch" @click.stop="toggleEnable('AIChat', 'AI 互动')">
          <el-switch v-model="configure.AIChat.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['AIChat'].timeRemaining)
          ? shoWDialogBuy(
              featureList['AIChat']['productKey'],
              '基础包',
              'AIChat'
            )
          : featureList['AIChat'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.AIChat.enable
          ? ''
          : toggleEnable('AIChat', 'AI 互动')
      "
      :class="{
        'no-buy': isNaN(featureList['AIChat'].timeRemaining),
        expired: featureList['AIChat'].timeRemaining <= 0,
        'shut-off': !configure.AIChat.enable,
      }"
    >
      <el-row>
        <el-col :span="5">互动标志</el-col>
        <el-col :span="19">
          <div class="block-tag">
            弹幕中带有
            <span class="green">@</span>
            符号的句子，机器人会进行AI互动。可自定义为
            <span class="green">@小强</span> ，这样带有
            <span class="green">@小强</span> 的句子才会AI互动。
          </div>
          <el-tag
            :key="tag"
            v-for="tag in configure.AIChat.symbolList"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
            placeholder="请输入机器人互动标志"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >新增</el-button
          >
          <!-- <el-input
            v-model.trim="configure.AIChat.symbol"
            @blur="checkSymbol"
            placeholder="请输入机器人互动标志"
          ></el-input> -->
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('AI 聊天', 'AIChat')"
          >「AI 互动」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      inputVisible: false,
      inputValue: "",
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  mounted() {},
  methods: {
    checkSymbol() {
      if (!this.configure.AIChat.symbol.length) {
        this.configure.AIChat.symbol = "@";
      }
    },
    handleClose(tag) {
      this.configure.AIChat.symbolList.splice(
        this.configure.AIChat.symbolList.indexOf(tag),
        1
      );
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (
        !!~inputValue.indexOf("/{") ||
        !!~inputValue.indexOf("{") ||
        !!~inputValue.indexOf("/")
      ) {
        return this.$message({
          showClose: true,
          message: "互动符号不能含有'/'或'{'符号",
          type: "error",
        });
      }
      if (inputValue) {
        this.configure.AIChat.symbolList.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style scoped>
.el-tag {
  margin-right: 10px;
  margin-bottom: 10px;
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
}
</style>
